/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  locale: 'uk',
  Pagination: {
    items_per_page: '/ сторінці',
    jump_to: 'Перейти',
    jump_to_confirm: 'підтвердити',
    page: '',
    prev_page: 'Попередня сторінка',
    next_page: 'Наступна сторінка',
    prev_5: 'Попередні 5 сторінок',
    next_5: 'Наступні 5 сторінок',
    prev_3: 'Попередні 3 сторінки',
    next_3: 'Наступні 3 сторінки'
  },
  DatePicker: {
    lang: {
      placeholder: 'Оберіть дату',
      yearPlaceholder: 'Оберіть рік',
      quarterPlaceholder: 'Оберіть квартал',
      monthPlaceholder: 'Оберіть місяць',
      weekPlaceholder: 'Оберіть тиждень',
      rangePlaceholder: ['Початкова дата', 'Кінцева дата'],
      rangeYearPlaceholder: ['Початковий рік', 'Рік закінчення'],
      rangeMonthPlaceholder: ['Початковий місяць', 'Кінцевий місяць'],
      rangeWeekPlaceholder: ['Початковий тиждень', 'Кінцевий тиждень'],
      locale: 'uk_UA',
      today: 'Сьогодні',
      now: 'Зараз',
      backToToday: 'Поточна дата',
      ok: 'Ok',
      clear: 'Очистити',
      month: 'Місяць',
      year: 'Рік',
      timeSelect: 'Обрати час',
      dateSelect: 'Обрати дату',
      monthSelect: 'Обрати місяць',
      yearSelect: 'Обрати рік',
      decadeSelect: 'Обрати десятиріччя',
      yearFormat: 'YYYY',
      dateFormat: 'D-M-YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D-M-YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Попередній місяць (PageUp)',
      nextMonth: 'Наступний місяць (PageDown)',
      previousYear: 'Попередній рік (Control + left)',
      nextYear: 'Наступний рік (Control + right)',
      previousDecade: 'Попереднє десятиріччя',
      nextDecade: 'Наступне десятиріччя',
      previousCentury: 'Попереднє століття',
      nextCentury: 'Наступне століття'
    },
    timePickerLocale: {
      placeholder: 'Оберіть час',
      rangePlaceholder: ['Час початку', 'Час закінчення']
    }
  },
  TimePicker: {
    placeholder: 'Оберіть час',
    rangePlaceholder: ['Час початку', 'Час закінчення']
  },
  Calendar: {
    lang: {
      placeholder: 'Оберіть дату',
      rangePlaceholder: ['Початкова дата', 'Кінцева дата'],
      locale: 'uk_UA',
      today: 'Сьогодні',
      now: 'Зараз',
      backToToday: 'Поточна дата',
      ok: 'Ok',
      clear: 'Очистити',
      month: 'Місяць',
      year: 'Рік',
      timeSelect: 'Обрати час',
      dateSelect: 'Обрати дату',
      monthSelect: 'Обрати місяць',
      yearSelect: 'Обрати рік',
      decadeSelect: 'Обрати десятиріччя',
      yearFormat: 'YYYY',
      dateFormat: 'D-M-YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D-M-YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Попередній місяць (PageUp)',
      nextMonth: 'Наступний місяць (PageDown)',
      previousYear: 'Попередній рік (Control + left)',
      nextYear: 'Наступний рік (Control + right)',
      previousDecade: 'Попереднє десятиріччя',
      nextDecade: 'Наступне десятиріччя',
      previousCentury: 'Попереднє століття',
      nextCentury: 'Наступне століття'
    },
    timePickerLocale: {
      placeholder: 'Оберіть час'
    }
  },
  Table: {
    filterTitle: 'Фільтрувати',
    filterConfirm: 'OK',
    filterReset: 'Скинути',
    selectAll: 'Обрати всі',
    selectInvert: 'Інвертувати вибір'
  },
  Modal: {
    okText: 'Гаразд',
    cancelText: 'Скасувати',
    justOkText: 'Гаразд'
  },
  Popconfirm: {
    okText: 'Гаразд',
    cancelText: 'Скасувати'
  },
  Transfer: {
    searchPlaceholder: 'Введіть текст для пошуку',
    itemUnit: 'елем.',
    itemsUnit: 'елем.'
  },
  Upload: {
    uploading: 'Завантаження ...',
    removeFile: 'Видалити файл',
    uploadError: 'Помилка завантаження',
    previewFile: 'Попередній перегляд файлу',
    downloadFile: 'Завантажити файл'
  },
  Empty: {
    description: 'Даних немає'
  },
  Icon: {
    icon: 'іконка'
  },
  Text: {
    edit: 'Редагувати',
    copy: 'Копіювати',
    copied: 'Скопійовано',
    expand: 'Розгорнути'
  },
  PageHeader: {
    back: 'Назад'
  }
};
